import { useEffect, useState } from "react";
import "./admin.css";

import {
  fetchUserSubscriptions,
  createUserSubscription,
  updateUserSubscription,
  deleteUserSubscription,
  fetchSubscriptions,
} from "../utils/api";

const emptyForm = {
  user_id: "",
  subscription_id: "",
  credits_used: 0,
  prints_used: 0,
  calls_used: 0,
  daily_prints_used: 0,
  end_date: "",
};

export default function UserSubscriptions() {
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const [plans, setPlans] = useState([]);
const [viewItem, setViewItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [showModal, setShowModal] = useState(false);
const view = (item) => {
  setViewItem(item);
};
  const load = async () => {
    try {
      setLoading(true);

      const [subsData, plansData] = await Promise.all([
        fetchUserSubscriptions(),
        fetchSubscriptions(),
      ]);

      setUserSubscriptions(subsData || []);
      setPlans(plansData || []);
    } catch (err) {
      alert(err.message || "Failed to load user subscriptions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const formatDateForInput = (value) => {
    if (!value) return "";
    return new Date(value).toISOString().slice(0, 10);
  };

  const openCreate = () => {
    setForm({
      ...emptyForm,
      end_date: formatDateForInput(
        new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
      ),
    });

    setEditingId(null);
    setShowModal(true);
  };

  const closeModal = () => {
    setForm(emptyForm);
    setEditingId(null);
    setShowModal(false);
  };

  const edit = (item) => {
    setEditingId(item.id);

    setForm({
      user_id: item.user_id || "",
      subscription_id: item.subscription_id || "",
      credits_used: item.credits_used ?? 0,
      prints_used: item.prints_used ?? 0,
      calls_used: item.calls_used ?? 0,
      daily_prints_used: item.daily_prints_used ?? 0,
      end_date: formatDateForInput(item.end_date),
    });

    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((p) => ({
      ...p,
      [name]: value,
    }));
  };

  const submit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        user_id: Number(form.user_id),
        subscription_id: Number(form.subscription_id),
        credits_used: Number(form.credits_used),
        prints_used: Number(form.prints_used),
        calls_used: Number(form.calls_used),
        daily_prints_used: Number(form.daily_prints_used),
        end_date: form.end_date,
      };

      if (editingId) {
        await updateUserSubscription(editingId, payload);
      } else {
        await createUserSubscription(payload);
      }

      closeModal();
      await load();
    } catch (err) {
      alert(err.message || "Failed to save user subscription");
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Remove this user subscription?")) return;

    try {
      await deleteUserSubscription(id);
      await load();
    } catch (err) {
      alert(err.message || "Failed to remove user subscription");
    }
  };

  const getStatus = (endDate) => {
    if (!endDate) return "Unknown";
    return new Date(endDate) > new Date() ? "Active" : "Expired";
  };

  return (
    <div className="users-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">User Subscriptions</h1>
          <p className="page-subtitle">
            Add, remove, and update users' subscription usage
          </p>
        </div>

        <button className="action-btn activate" onClick={openCreate}>
          + Add User Subscription
        </button>
      </div>

      {loading ? (
        <p>Loading user subscriptions…</p>
      ) : (
        <div className="table-wrapper">
          <table className="users-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Plan</th>
                <th>Credits Used</th>
                <th>Prints Used</th>
                <th>Calls Used</th>
                <th>Daily Prints</th>
                <th>End Date</th>
                <th>Status</th>
                <th style={{ width: "190px" }}>Action</th>
              </tr>
            </thead>

            <tbody>
              {userSubscriptions.map((s) => (
                <tr key={s.id}>
                  <td>
                    <strong>
                      {s.User?.name || `User #${s.user_id}`}
                    </strong>
                  </td>

                  <td>{s.User?.email || "—"}</td>

                  <td>
                    {s.Subscription?.title || `Plan #${s.subscription_id}`}
                  </td>

                  <td>{Number(s.credits_used || 0).toLocaleString()}</td>
                  <td>{Number(s.prints_used || 0).toLocaleString()}</td>
                  <td>{Number(s.calls_used || 0).toLocaleString()}</td>
                  <td>{Number(s.daily_prints_used || 0).toLocaleString()}</td>

                  <td>
                    {s.end_date
                      ? new Date(s.end_date).toLocaleDateString()
                      : "—"}
                  </td>

                  <td>
                    <span
                      className={
                        getStatus(s.end_date) === "Active"
                          ? "status-active"
                          : "status-inactive"
                      }
                    >
                      {getStatus(s.end_date)}
                    </span>
                  </td>

                  <td>
                   <button className="action-btn activate" onClick={() => view(s)}>
  View
</button>

<button className="action-btn activate" onClick={() => edit(s)}>
  Edit
</button>

<button className="action-btn deactivate" onClick={() => remove(s.id)}>
  Remove
</button>
                  </td>
                </tr>
              ))}

              {userSubscriptions.length === 0 && (
                <tr>
                  <td colSpan="10" className="empty">
                    No user subscriptions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
{viewItem && (
  <div className="modal-overlay">
    <div className="modal-box">
      <div className="modal-header">
        <h2>Subscription Usage</h2>

        <button className="modal-close" onClick={() => setViewItem(null)}>
          ×
        </button>
      </div>

      <div className="subscription-form modal-form">
        <p><strong>User:</strong> {viewItem.User?.name || `User #${viewItem.user_id}`}</p>
        <p><strong>Email:</strong> {viewItem.User?.email || "—"}</p>
        <p><strong>Plan:</strong> {viewItem.Subscription?.title || `Plan #${viewItem.subscription_id}`}</p>
        <p><strong>Status:</strong> {getStatus(viewItem.end_date)}</p>
        <p><strong>End Date:</strong> {viewItem.end_date ? new Date(viewItem.end_date).toLocaleDateString() : "—"}</p>

        <hr />

        <p><strong>Credits Used:</strong> {Number(viewItem.credits_used || 0).toLocaleString()}</p>
        <p><strong>Prints Used:</strong> {Number(viewItem.prints_used || 0).toLocaleString()}</p>
        <p><strong>Calls Used:</strong> {Number(viewItem.calls_used || 0).toLocaleString()}</p>
        <p><strong>Daily Prints Used:</strong> {Number(viewItem.daily_prints_used || 0).toLocaleString()}</p>

        <div className="form-actions">
          <button
            className="action-btn deactivate"
            type="button"
            onClick={() => setViewItem(null)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div className="modal-header">
              <h2>
                {editingId
                  ? "Update User Subscription"
                  : "Add User Subscription"}
              </h2>

              <button className="modal-close" onClick={closeModal}>
                ×
              </button>
            </div>

            <form className="subscription-form modal-form" onSubmit={submit}>
              <div className="form-grid">
                <input
                  name="user_id"
                  type="number"
                  placeholder="User ID"
                  value={form.user_id}
                  onChange={handleChange}
                  required
                  disabled={!!editingId}
                />

                <select
                  name="subscription_id"
                  value={form.subscription_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Plan</option>

                  {plans.map((plan) => (
                    <option key={plan.id} value={plan.id}>
                      {plan.title}
                    </option>
                  ))}
                </select>

                <input
                  name="credits_used"
                  type="number"
                  placeholder="Credits used"
                  value={form.credits_used}
                  onChange={handleChange}
                  min="0"
                  required
                />

                <input
                  name="prints_used"
                  type="number"
                  placeholder="Prints used"
                  value={form.prints_used}
                  onChange={handleChange}
                  min="0"
                  required
                />

                <input
                  name="calls_used"
                  type="number"
                  step="0.001"
                  placeholder="Calls used"
                  value={form.calls_used}
                  onChange={handleChange}
                  min="0"
                  required
                />

                <input
                  name="daily_prints_used"
                  type="number"
                  placeholder="Daily prints used"
                  value={form.daily_prints_used}
                  onChange={handleChange}
                  min="0"
                  required
                />

                <input
                  name="end_date"
                  type="date"
                  placeholder="End date"
                  value={form.end_date}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-actions">
                <button
                  className="action-btn activate"
                  type="submit"
                  disabled={saving}
                >
                  {saving
                    ? "Saving…"
                    : editingId
                    ? "Update Subscription"
                    : "Add Subscription"}
                </button>

                <button
                  className="action-btn deactivate"
                  type="button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}